import nacl from 'tweetnacl';
import naclUtil from 'tweetnacl-util';

const canonicalize = (value: unknown): unknown => {
  if (Array.isArray(value)) return value.map(canonicalize);
  if (value && typeof value === 'object') {
    return Object.keys(value as Record<string, unknown>)
      .sort()
      .reduce<Record<string, unknown>>((result, key) => {
        const item = (value as Record<string, unknown>)[key];
        if (item !== undefined) result[key] = canonicalize(item);
        return result;
      }, {});
  }
  return value;
};

export const digestRecoveryPendingRow = (
  queue: 'pending_operations' | 'pending_deletions',
  row: Record<string, unknown>
): string => naclUtil.encodeBase64(
  nacl.hash(naclUtil.decodeUTF8(JSON.stringify(canonicalize({ queue, row }))))
);
